module.exports = __webpack_public_path__ + "img/yinlian.e71b0cbe.png";